module.exports = __webpack_public_path__ + "img/hero-dropdown-search-infiniti.939985fe.png";